import { forwardRef } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

export const Textarea = forwardRef(
  ({ label, name, placeholder, value, onChange, className, required, ...props }, ref) => {
    const { t } = useTranslation();
    return (
      <div className="w-full">
        {label && (
          <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">
            {label}
            {required && <span className="text-red-500 ms-1">*</span>}
          </label>
        )}
        <textarea
          ref={ref}
          id={name}
          name={name}
          placeholder={placeholder || ''}
          value={value}
          onChange={onChange}
          className={clsx(
            'block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm',
            'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500',
            'transition-colors duration-200',
            className
          )}
          required={required}
          {...props}
        />
      </div>
    );
  }
);